// extracted by mini-css-extract-plugin
export default {"logo":"styles_logo__aNXf1","icon":"styles_icon__7VgFa"};